<!--<div class="card mb-0">-->
Sitter
<div *ngIf="!sitter" class="text-900 font-medium text-xl">NOT FOUND</div>
<div *ngIf="sitter" class="flex">
  <div class="pr-3" style="width: 200px">
    <img [alt]="sitter.firstName" [src]="sitter.imageURL.length < 5 ? imageURL : sitter.imageURL"
         class="shadow-4" width="100%"/>
  </div>
  <div class="flex">
    <div style="width: 100px">
      <p style="font-weight: bolder">ID</p>
      <p>First Name</p>
      <p>Last Name</p>
      <p>Phone</p>
      <p>Email</p>
    </div>
    <div>
      <p><a [routerLink]="['/' ,'dashboard', 'sitter', 'detail', sitter.id]"> #{{ sitter.id }} </a></p>
      <p> {{ sitter.firstName }} </p>
      <p> {{ sitter.lastName }} </p>
      <p><a href="tel:{{ sitter.phoneNumber }}">{{ sitter.phoneNumber }}</a></p>
      <p><a href="mailto:{{ sitter.email }}">{{ sitter.email }}</a></p>
    </div>
  </div>
</div>
<!--</div>-->
